// extracted by mini-css-extract-plugin
export default {"unit":"8px","mdBreak":"1024px","colorLightGrey":"#E4E4E4","colorViolet":"#080837","cardsContainer":"TyVO3A7BYC3Ze03R4YZw","latestBookingCard":"UbZ6vZ56fgDxNudqgBwt"};